<script lang="ts" setup>
import type { FilterDropdownOption } from './FilterDropdown.vue'

defineProps<{
  sortOptions: FilterDropdownOption[]
  activeSortOption?: FilterDropdownOption
  activeFiltersCount: number

  gridOptions: FilterDropdownOption[]
  activeGridOption?: FilterDropdownOption
}>()
defineEmits<{
  (e: 'toggleFilterMenu'): void
  (e: 'sortOptionSelected', option: FilterDropdownOption): void
  (e: 'gridOptionSelected', option: FilterDropdownOption): void
}>()
const { $t } = useNuxtApp()
</script>

<template>
  <div class="filter-controls">
    <button
      class="filter-controls__filter-btn"
      :aria-label="$t('openCloseFilterMenuAria')"
      data-test="open-all-filters-button"
      data-filter-button-ignored-el
      @click="$emit('toggleFilterMenu')"
    >
      <img src="/icons/filter.svg" data-filter-button-ignored-el>
      <p>{{ $t('filter') }}</p>
      <figure v-if="activeFiltersCount > 0">
        {{ activeFiltersCount }}
      </figure>
    </button>

    <!-- Sort -->
    <figure class="filter-controls__divider" />
    <FilterDropdown
      :label="$t('sortLabel')"
      :options="sortOptions"
      :selected="activeSortOption"
      icon="sort"
      @selected="o => $emit('sortOptionSelected', o)"
    />

    <!-- Grid -->
    <figure class="filter-controls__divider" />
    <FilterDropdown
      :label="$t('gridLabel')"
      :options="gridOptions"
      :selected="activeGridOption"
      icon="grid"
      @selected="o => $emit('gridOptionSelected', o)"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/rules/breakpoints';
@import '~/assets/scss/typography/body';

.filter-controls {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  &__divider {
    position: relative;
    height: 2.4rem;
    width: 1px;
    background-color: var(--gray-dark);
  }

  &__filter-btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.2rem 1.2rem;
    gap: 1rem;

    img {
      height: 2rem;
      width: 2rem;
    }

    p {
      @include body2;
      line-height: unset;
      margin-top: 0.2rem;
    }

    figure {
      @include caption2;
      line-height: unset;

      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      align-items: center;
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      background-color: var(--black);
      color: var(--white);
      margin: 0;
      padding: 0;
      padding-top: 0.2rem;
    }
  }
}
</style>
